import queryString from "query-string";
import { Alert, Card } from "react-bootstrap";
import { Link } from "react-router";

import { CorvusList } from "../../components/CorvusList";
import MissionListItem from "../../components/MissionListItem";
import urls from "../../urls.jsx";

export default function MissionList(props) {
    const viewAllMissionsBaseUrl = urls.locationMissions(
        props.organizationId,
        props.locationId,
    );
    const search = props.droneId
        ? queryString.stringify({ droneIds: props.droneId })
        : "";
    const viewAllMissionsUrl = search
        ? `${viewAllMissionsBaseUrl}?${search}`
        : viewAllMissionsBaseUrl;

    return (
        <Card className={props.className}>
            <Card.Header className="d-flex justify-content-between">
                <div style={{ fontWeight: "bold" }}>
                    {props.title || "Missions"}
                </div>
                <Link to={viewAllMissionsUrl}>View all</Link>
            </Card.Header>
            {props.missions.length === 0 && (
                <Card.Body>
                    <Alert className="text-center mb-0" variant="primary">
                        <div className="text-muted">No missions</div>
                    </Alert>
                </Card.Body>
            )}
            {props.missions.length > 0 && (
                <CorvusList>
                    {props.children}
                    {props.missions.map((mission) => (
                        <MissionListItem
                            key={mission.id}
                            mission={mission}
                            timeDisplayFormat="YYYY-MM-DD HH:mm:ss"
                            showOrganizationName={false}
                        />
                    ))}
                </CorvusList>
            )}
        </Card>
    );
}
